export function isTouchDevice() {
  // See https://stackoverflow.com/a/4819886
  return "ontouchstart" in window || navigator.maxTouchPoints > 0;
}
